import { useState } from 'react';
import { Pencil, Ban } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import type { CondicaoPagamento } from '../types';

interface Props {
  condicoes: CondicaoPagamento[];
  onEdit: (condicao: CondicaoPagamento) => void;
  onBloquear: (id: number) => void;
}

export const CondicoesPagamentoTable = ({ condicoes, onEdit, onBloquear }: Props) => {
  const [bloquearId, setBloquearId] = useState<number | null>(null);

  return (
    <div className="space-y-4">
      <div className="border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-24">Código</TableHead>
              <TableHead>Descrição</TableHead>
              <TableHead className="text-center">Parcelas</TableHead>
              <TableHead className="text-center">Status</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {condicoes.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-muted-foreground py-8">
                  Nenhuma condição de pagamento cadastrada
                </TableCell>
              </TableRow>
            ) : (
              condicoes.map((condicao) => (
                <TableRow key={condicao.id}>
                  <TableCell className="font-mono">{condicao.codigoCondicao || '-'}</TableCell>
                  <TableCell className="font-medium">{condicao.descricao || '-'}</TableCell>
                  <TableCell className="text-center">{condicao.quantidadeParcelas}x</TableCell>
                  <TableCell className="text-center">
                    <Badge variant={condicao.isBloqueado ? 'secondary' : 'success'}>
                      {condicao.isBloqueado ? 'Bloqueada' : 'Ativa'}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-1">
                      <Button variant="ghost" size="icon" onClick={() => onEdit(condicao)}>
                        <Pencil className="h-4 w-4" />
                      </Button>
                      {!condicao.isBloqueado && (
                        <Button variant="ghost" size="icon" onClick={() => setBloquearId(condicao.id)}>
                          <Ban className="h-4 w-4" />
                        </Button>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>

      <AlertDialog open={!!bloquearId} onOpenChange={() => setBloquearId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Bloquear condição de pagamento</AlertDialogTitle>
            <AlertDialogDescription>Tem certeza que deseja bloquear esta condição?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={() => { if (bloquearId) { onBloquear(bloquearId); setBloquearId(null); } }}>
              Bloquear
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
